import { connect } from "react-redux";
import {
  closePortfolioModal,
  closePortfolioSidebar,
  openPortfolioModal,
  requestPortfolioAccess,
  switchPortfolios,
} from "actions/portfolio";
import { isOwnerSelector } from "selectors/currentUser";

import PortfolioSidebar from "./PortfolioSidebar";

const mapStateToProps = ({ currentUser, isSidebarOpen, portfolios, selectedPortfolioIDs }) => ({
  currentUser,
  portfolios,
  selectedPortfolioIDs,
  isOpen: isSidebarOpen,
  isOwner: isOwnerSelector({ currentUser }),
});

const mapDispatchToProps = (dispatch) => ({
  onClose: () => dispatch(closePortfolioSidebar()),
  onClosePortfolioModal: () => dispatch(closePortfolioModal()),
  onOpenPortfolioModal: (portfolioID) => dispatch(openPortfolioModal(portfolioID)),
  onRequestAccessPortfolio: (portfolio) => dispatch(requestPortfolioAccess(portfolio.id)),
  onSelectPortfolioIDs: (portfolioIDs) => dispatch(switchPortfolios(portfolioIDs)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PortfolioSidebar);
